import { useTranslation } from '@packages/utils';
import useGetValidationData from 'components/Base/Form/validationRules';

const useGetFormData = () => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.resources-tab.add-resource.modal.form',
  });
  const { validationRules } = useGetValidationData();

  const resourceTypeOptions = [
    {
      value: 'DOCUMENT',
      label: t('resource-type.DOCUMENT'),
      'data-cy': 'resource_document_option',
    },
    {
      value: 'LINK',
      label: t('resource-type.LINK'),
      'data-cy': 'resource_link_option',
    },
  ];

  const documentTypeOptions = [
    {
      value: 'GENERAL_ELC_DOCUMENT',
      label: t('document-type.GENERAL_ELC_DOC'),
      'data-cy': 'general_elc_docs_radio',
    },
    {
      value: 'ELC_SPECIFIC_DOCUMENT',
      label: t('document-type.ELC_SPECIFIC_DOC'),
      'data-cy': 'elc_specific_docs_radio',
    },
  ];

  const pmScopeOptions = [
    {
      value: 'ALL_PM',
      label: 'Include all ELC PMs',
    },
    {
      value: 'MY_PM',
      label: 'Include my ELC PMs only',
    },
  ];

  const addResourcesFormFields = {
    resourceType: {
      name: 'resourceType',
    },
    documentType: {
      name: 'documentType',
      label: '',
      rules: [validationRules.requiredField()],
    },
    fileUpload: {
      name: 'fileUpload',
      label: t('file.LABEL'),
      rules: [validationRules.requiredField()],
    },
    name: {
      name: 'name',
      label: t('title.LABEL'),
      placeholder: t('title.PLACEHOLDER'),
      rules: [validationRules.requiredField()],
    },
    url: {
      name: 'url',
      label: t('link.LABEL'),
      placeholder: t('link.PLACEHOLDER'),
      rules: [validationRules.requiredField(), validationRules.validUrl()],
    },
    pmScope: {
      name: 'pmScope',
      label: '',
      rules: [validationRules.requiredField()],
    },
  };

  return {
    addResourcesFormFields,
    resourceTypeOptions,
    documentTypeOptions,
    pmScopeOptions,
  };
};

export default useGetFormData;
